module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.campaigns.index.title')) + " (" + _vm._s(_vm.campaigns.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search
    },
    on: {
      "keydown": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, _vm._l((_vm.campaigns.items), function(c, i) {
    return _c('v-card', {
      key: i,
      nativeOn: {
        "click": function($event) {
          return _vm.edit(c)
        }
      }
    }, [_c('label', {
      staticClass: "cardLabel"
    }, [_c('span', {
      staticClass: "cardBadge"
    }, [_vm._v(_vm._s(c.campaignType))])]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('span', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(c.amount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDateLong(c.createdAt)))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "cardinnerBox"
    }, [_c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-info",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "cardContent cardContent--small"
    }, [_vm._v("\n              " + _vm._s(c.description) + "\n            ")])])])])
  }), 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "pagination": _vm.campaigns.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08375ed8","hasScoped":false}!./src/app/pages/withNavigation/campaigns/index/index.html
// module id = 2902
// module chunks = 1